/**
 * @generated SignedSource<<09080cbe1aa0c25804c99968246ffcbb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type EventInvitePageAcceptMutation$variables = {
  code?: string | null | undefined;
  id: string;
};
export type EventInvitePageAcceptMutation$data = {
  readonly acceptEventInvite: {
    readonly event: {
      readonly id: string;
      readonly slug: string;
    };
    readonly id: string;
  };
};
export type EventInvitePageAcceptMutation = {
  response: EventInvitePageAcceptMutation$data;
  variables: EventInvitePageAcceptMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "code"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v2 = [
  {
    "kind": "Variable",
    "name": "code",
    "variableName": "code"
  },
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "Event",
  "kind": "LinkedField",
  "name": "event",
  "plural": false,
  "selections": [
    (v3/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slug",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "EventInvitePageAcceptMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "acceptEventInvite",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "EventInvitePageAcceptMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "acceptEventInvite",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v3/*: any*/),
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "f91e2bb308e2504f0929013a69a17605",
    "id": null,
    "metadata": {},
    "name": "EventInvitePageAcceptMutation",
    "operationKind": "mutation",
    "text": "mutation EventInvitePageAcceptMutation(\n  $id: ID!\n  $code: String\n) {\n  acceptEventInvite(id: $id, code: $code) {\n    __typename\n    id\n    event {\n      id\n      slug\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "3fd3b4ce87605bb995ab5ff55dbfb4e5";

export default node;
